// import { createSlice } from "@reduxjs/toolkit";
// import Cookies from "js-cookie";

// const initialState = {
//   items: Cookies.get("items") ? JSON.parse(Cookies.get("items")) : [],
//   favorites: JSON.parse(Cookies.get("favorites") || "[]"),
//   totalItems: Cookies.get("totalItems") ? Number(Cookies.get("totalItems")) : 0,
//   configUrl: Cookies.get("configUrl") || "",
//   baseAssetUrl: Cookies.get("baseAssetUrl") || "",
//   modifiedGLB: null,
//   selectedId: Cookies.get("AddressId") ? Number(Cookies.get("AddressId")) : 0,
//   selectedSize: null,
//   glbId: null,
//   glbItems: Cookies.get("glbItems") ? JSON.parse(Cookies.get("glbItems")) : [],
// productItems: Cookies.get("productItems")
//     ? JSON.parse(Cookies.get("productItems"))
//     : [],
// };
// let tempId = 0;

// const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     setSelectedAddressId: (state, action) => {
//       state.selectedId = action.payload;
//       Cookies.set("AddressId", state.selectedId);
//     },
//     setglbId: (state, action) => {
//       state.glbId = action.payload;
//     },
//     setSelectedSizeDetails: (state, action) => {
//       state.selectedSize = action.payload;
//     },
//     setModifiedGLB: (state, action) => {
//       console.log("Storing modified GLB file:", action.payload);
//       state.modifiedGLB = action.payload;
//     },
//     resetModifiedGLB: (state) => {
//       console.log("Removing modified GLB from Redux.");
//       state.modifiedGLB = null;
//     },
//     ConfigUrl: (state, action) => {
//       console.log("state.configUrl : ", action.payload);
//       state.configUrl = action.payload;
//       Cookies.set("configUrl", state.configUrl);
//     },
//     baseAssetUrl: (state, action) => {
//       console.log("state.configUrl : ", action.payload);
//       state.baseAssetUrl = action.payload;
//       Cookies.set("baseAssetUrl", state.baseAssetUrl);
//     },

//     setGlbItems: (state, action) => {
//       state.glbItems = action.payload;
//     },
//     addGlbRow: (state, action) => {
//       const { cart_id, row } = action.payload;
//       console.log("addGlbRow : ", action.payload);
//       let item = state.glbItems.find((g) => g.cart_id === cart_id);

//       if (item) {
//         item.data.push(row);
//       } else {
//         state.glbItems.push({
//           cart_id,
//           data: [row],
//         });
//         const newTotal = state.totalItems + 1;
//         state.totalItems = newTotal;
//         console.log("state.totalItems : ", newTotal);
//         Cookies.set("totalItems", newTotal);
//       }
//       Cookies.set("glbItems", JSON.stringify(state.glbItems));
//     },

//     deleteAllGlbItems: (state) => {
//       state.glbItems = [];
//       Cookies.remove("glbItems");
//       state.productItems = [];
//       Cookies.remove("productItems");
//       state.totalItems=0;
//       Cookies.set("glbItems", JSON.stringify(state.glbItems));
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//       Cookies.set("totalItems", JSON.stringify(state.totalItems));
//     },

//     deleteGlbRow: (state, action) => {
//       const { cart_id, data_id } = action.payload;
//       const cartIndex = state.glbItems.findIndex((g) => g.cart_id === cart_id);
//       if (cartIndex !== -1) {
//         const cart = state.glbItems[cartIndex];
//         cart.data = cart.data.filter((item) => item.id !== data_id);
//         // Optional: Remove cart if no data left
//         if (cart.data.length === 0) {
//           state.glbItems.splice(cartIndex, 1);
//         }
//       }
//       Cookies.set("glbItems", JSON.stringify(state.glbItems));
//     },

//     deleteEntireGlbCart: (state, action) => {
//       const { cart_id } = action.payload;
//       console.log("delete full : ", cart_id);

//       state.glbItems = state.glbItems.filter((g) => g.cart_id !== cart_id);

//       Cookies.set("glbItems", JSON.stringify(state.glbItems));
//       state.totalItems -= 1;
//       Cookies.set("totalItems", state.totalItems);
//     },
//     deleteEntireProductCart: (state, action) => {
//       const { cart_id } = action.payload;
//       console.log("delete full product cart: ", cart_id);

//       state.productItems = state.productItems.filter(
//         (p) => p.cart_id !== cart_id
//       );

//       Cookies.set("productItems", JSON.stringify(state.productItems));
//       state.totalItems -= 1;
//       Cookies.set("totalItems", state.totalItems);
//     },

//     updateGlbRow: (state, action) => {
//       console.log("action.payload : ", action.payload);
//       const { cart_id, data_id, key, value } = action.payload;
//       const cart = state.glbItems.find((g) => g.cart_id === cart_id);
//       if (cart) {
//         const dataItem = cart.data.find((item) => item.id === data_id);
//         if (dataItem) {
//           dataItem[key] = value;
//         }
//       }
//       Cookies.set("glbItems", JSON.stringify(state.glbItems));
//     },

//     addFavorite: (state, action) => {
//       console.log("favourite : ", action.payload);
//       const product = action.payload;
//       const existingProduct = state.favorites.find(
//         (item) => item.id === product.id
//       );

//       if (!existingProduct) {
//         state.favorites.push(product);
//       }

//       Cookies.set("favorites", JSON.stringify(state.favorites));
//     },

//     removeFavorite: (state, action) => {
//       state.favorites = state.favorites.filter(
//         (item) => item.id !== action.payload
//       );
//       Cookies.set("favorites", JSON.stringify(state.favorites));
//     },
//     setProductItems: (state, action) => {
//       state.productItems = action.payload;
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },

//     addProductRow: (state, action) => {
//       const {
//         product_id,
//         cart_id,
//         product_price,
//         product_image,
//         product_name,
//         row,
//       } = action.payload;
//       console.log("action.payload product : ", action.payload);
//       const product = state.productItems.find(
//         (item) => item.product_id === product_id
//       );
//       console.log("product : ", product);
//       if (product) {
//         product.data.push(row);
//       } else {
//         state.productItems.push({
//           product_id,
//           product_price,
//           product_image,
//           product_name,
//           cart_id,
//           data: [row],
//         });
//         const newTotal = state.totalItems + 1;
//         state.totalItems = newTotal;
//         console.log("state.totalItems : ", newTotal);
//         Cookies.set("totalItems", newTotal);
//       }
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },

//     updateProductRow: (state, action) => {
//       const { product_id, row_id, key, value } = action.payload;
//       const product = state.productItems.find(
//         (item) => item.product_id === product_id
//       );

//       if (product) {
//         if (row_id) {
//           const row = product.data.find((row) => row.id === row_id);
//           if (row) {
//             row[key] = value;
//           }
//         } else if (product.data && product.data.length > 0) {
//           const lastRow = product.data[product.data.length - 1];
//           lastRow[key] = value;
//         }
//       }
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },

//     deleteProductRow: (state, action) => {
//       const { product_id, row_id } = action.payload;
//       const product = state.productItems.find(
//         (item) => item.product_id === product_id
//       );

//       if (product) {
//         if (row_id) {
//           product.data = product.data.filter((row) => row.id !== row_id);
//         } else if (product.data.length > 0) {
//           product.data.pop();
//         }

//         if (product.data.length === 0) {
//           state.productItems = state.productItems.filter(
//             (item) => item.product_id !== product_id
//           );
//         }
//       }
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },

//   addProductCustomization: (state, action) => {
//   const { product_id, ...customizations } = action.payload;

//   const productIndex = state.productItems.findIndex(
//     item => item.product_id === product_id
//   );

//   if (productIndex !== -1) {
//     Object.assign(state.productItems[productIndex], customizations);
//   }
//   //  Cookies.set("productItems", JSON.stringify(state.productItems));
// },
//     addTempProductRow: (state, action) => {
//       const { product_id, row } = action.payload;
//       if (!state.tempProductRows[product_id]) {
//         state.tempProductRows[product_id] = [];
//       }
//       state.tempProductRows[product_id].push(row);
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },

//     updateTempProductRow: (state, action) => {
//       const { product_id, row_id, key, value } = action.payload;
//       const tempRows = state.tempProductRows[product_id];
//       if (tempRows) {
//         const row = tempRows.find((row) => row.id === row_id);
//         if (row) {
//           row[key] = value;
//         }
//       }
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },

//     removeTempProductRow: (state, action) => {
//       const { product_id, row_id } = action.payload;
//       const tempRows = state.tempProductRows[product_id];
//       if (tempRows) {
//         state.tempProductRows[product_id] = tempRows.filter(
//           (row) => row.id !== row_id
//         );
//       }
//       Cookies.set("productItems", JSON.stringify(state.productItems));
//     },
//   },
// });

// export const {
//   addProductCustomization,
//   setProductItems,
//   addProductRow,
//   updateProductRow,
//   deleteEntireProductCart,
//   deleteProductRow,
//   addTempProductRow,
//   removeTempProductRow,
//   updateTempProductRow,
//   removeCart,
//   deleteEntireGlbCart,
//   deleteAllGlbItems,
//   ConfigUrl,
//   updateCartItem,
//   setModifiedGLB,
//   resetModifiedGLB,
//   setSelectedAddressId,
//   setSelectedSizeDetails,
//   setglbId,
//   addFavorite,
//   removeFavorite,
//   baseAssetUrl,
//   setGlbItems,
//   addGlbRow,
//   deleteGlbRow,
//   updateGlbRow,
// } = cartSlice.actions;

// export default cartSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: localStorage.getItem("items")
    ? JSON.parse(localStorage.getItem("items"))
    : [],
  favorites: JSON.parse(localStorage.getItem("favorites") || "[]"),
  totalItems: localStorage.getItem("totalItems")
    ? Number(localStorage.getItem("totalItems"))
    : 0,
  configUrl: localStorage.getItem("configUrl") || "",
  baseAssetUrl: localStorage.getItem("baseAssetUrl") || "",
  modifiedGLB: null,
  selectedId: localStorage.getItem("AddressId")
    ? Number(localStorage.getItem("AddressId"))
    : 0,
  selectedSize: null,
  glbId: null,
  glbItems: localStorage.getItem("glbItems")
    ? JSON.parse(localStorage.getItem("glbItems"))
    : [],
  productItems: localStorage.getItem("productItems")
    ? JSON.parse(localStorage.getItem("productItems"))
    : [],
    modelItems:localStorage.getItem("modelItems")
    ? JSON.parse(localStorage.getItem("modelItems"))
    : [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setSelectedAddressId: (state, action) => {
      state.selectedId = action.payload;
      localStorage.setItem("AddressId", state.selectedId);
    },
    setglbId: (state, action) => {
      state.glbId = action.payload;
    },
    setSelectedSizeDetails: (state, action) => {
      state.selectedSize = action.payload;
    },
    setModifiedGLB: (state, action) => {
      state.modifiedGLB = action.payload;
    },
    resetModifiedGLB: (state) => {
      state.modifiedGLB = null;
    },
    ConfigUrl: (state, action) => {
      state.configUrl = action.payload;
      localStorage.setItem("configUrl", state.configUrl);
    },
    baseAssetUrl: (state, action) => {
      state.baseAssetUrl = action.payload;
      localStorage.setItem("baseAssetUrl", state.baseAssetUrl);
    },
    setGlbItems: (state, action) => {
      state.glbItems = action.payload;
      localStorage.setItem("glbItems", JSON.stringify(state.glbItems));
    },
    addGlbRow: (state, action) => {
      const { cart_id, row } = action.payload;
      let item = state.glbItems.find((g) => g.cart_id === cart_id);

      if (item) {
        item.data.push(row);
      } else {
        state.glbItems.push({
          cart_id,
          data: [row],
        });
        state.totalItems += 1;
      }
      localStorage.setItem("glbItems", JSON.stringify(state.glbItems));
      localStorage.setItem("totalItems", state.totalItems);
    },
    deleteAllGlbItems: (state) => {
      state.glbItems = [];
      state.productItems = [];
      state.totalItems = 0;
      localStorage.removeItem("glbItems");
      localStorage.removeItem("productItems");
      localStorage.setItem("totalItems", "0");
    },
    deleteGlbRow: (state, action) => {
      const { cart_id, data_id } = action.payload;
      const cartIndex = state.glbItems.findIndex((g) => g.cart_id === cart_id);
      if (cartIndex !== -1) {
        const cart = state.glbItems[cartIndex];
        cart.data = cart.data.filter((item) => item.id !== data_id);
        if (cart.data.length === 0) {
          state.glbItems.splice(cartIndex, 1);
        }
      }
      localStorage.setItem("glbItems", JSON.stringify(state.glbItems));
    },
    deleteEntireGlbCart: (state, action) => {
      const { cart_id } = action.payload;
      state.glbItems = state.glbItems.filter((g) => g.cart_id !== cart_id);
      state.totalItems -= 1;
      localStorage.setItem("glbItems", JSON.stringify(state.glbItems));
      localStorage.setItem("totalItems", state.totalItems);
    },
    deleteEntireProductCart: (state, action) => {
      const { cart_id } = action.payload;
      state.productItems = state.productItems.filter(
        (p) => p.cart_id !== cart_id
      );
      state.totalItems -= 1;
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
      localStorage.setItem("totalItems", state.totalItems);
    },
    deleteEntireProductItems:(state)=>{
      console.log("state : ",state)

      console.log("state.productItems : ",state.productItems)
      state.totalItems=0
      state.productItems=[]
      localStorage.removeItem("productItems")
      localStorage.removeItem("totalItems")

    },
    updateGlbRow: (state, action) => {
      const { cart_id, data_id, key, value } = action.payload;
      const cart = state.glbItems.find((g) => g.cart_id === cart_id);
      if (cart) {
        const dataItem = cart.data.find((item) => item.id === data_id);
        if (dataItem) {
          dataItem[key] = value;
        }
      }
      localStorage.setItem("glbItems", JSON.stringify(state.glbItems));
    },
    addFavorite: (state, action) => {
      const product = action.payload;
      const existingProduct = state.favorites.find(
        (item) => item.id === product.id
      );
      if (!existingProduct) {
        state.favorites.push(product);
      }
      localStorage.setItem("favorites", JSON.stringify(state.favorites));
    },
    removeFavorite: (state, action) => {
      state.favorites = state.favorites.filter(
        (item) => item.id !== action.payload
      );
      localStorage.setItem("favorites", JSON.stringify(state.favorites));
    },
    setProductItems: (state, action) => {
      state.productItems = action.payload;
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },
    addProductRow: (state, action) => {
      const {
        product_id,
        cart_id,
        orderType,
        product_price,
        product_image,
        product_name,
        All_Size,
        All_Color,
        row,
      } = action.payload;
      const product = state.productItems.find(
        (item) => item.product_id === product_id
      );
      if (product) {
        product.data.push(row);
      } else {
        state.productItems.push({
          product_id,
          product_price,
          product_image,
          product_name,
          cart_id,
          orderType,
          All_Size:All_Size,
          All_Color:All_Color,
          data: [row],
        });
        state.totalItems += 1;
      }
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
      localStorage.setItem("totalItems", state.totalItems);
    },
    updateProductRow: (state, action) => {
      const { product_id, row_id, key, value } = action.payload;
      const product = state.productItems.find(
        (item) => item.product_id === product_id
      );
      if (product) {
        if (row_id) {
          const row = product.data.find((row) => row.id === row_id);
          if (row) {
            row[key] = value;
          }
        } else if (product.data && product.data.length > 0) {
          const lastRow = product.data[product.data.length - 1];
          lastRow[key] = value;
        }
      }
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },
    deleteProductRow: (state, action) => {
      const { product_id, row_id } = action.payload;
      const product = state.productItems.find(
        (item) => item.product_id === product_id
      );
      if (product) {
        if (row_id) {
          product.data = product.data.filter((row) => row.id !== row_id);
        } else if (product.data.length > 0) {
          product.data.pop();
        }
        if (product.data.length === 0) {
          state.productItems = state.productItems.filter(
            (item) => item.product_id !== product_id
          );
        }
      }
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },
    addProductCustomization: (state, action) => {
      const { product_id, ...customizations } = action.payload;
      console.log("action.payload; : ", action.payload);
      const productIndex = state.productItems.findIndex(
        (item) => item.product_id === product_id
      );
      if (productIndex !== -1) {
        state.productItems[productIndex] = {
          ...state.productItems[productIndex],
          ...customizations,
        };
        localStorage.setItem(
          "productItems",
          JSON.stringify(state.productItems)
        );
      }
    },
    addProductColorCustomization: (state, action) => {
      const { product_id, ...customizations } = action.payload;
      console.log("action.payload: ", action.payload);

      const productIndex = state.productItems.findIndex(
        (item) => item.product_id === product_id
      );

      if (productIndex !== -1) {
        const product = state.productItems[productIndex];

        if (product.data && product.data.length > 0) {
          const lastIndex = product.data.length - 1;
          product.data[lastIndex] = {
            ...product.data[lastIndex],
            ...customizations,
          };

          localStorage.setItem(
            "productItems",
            JSON.stringify(state.productItems)
          );
        }
      }
    },

    addTempProductRow: (state, action) => {
      const { product_id, row } = action.payload;
      if (!state.tempProductRows[product_id]) {
        state.tempProductRows[product_id] = [];
      }
      state.tempProductRows[product_id].push(row);
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },
    updateTempProductRow: (state, action) => {
      const { product_id, row_id, key, value } = action.payload;
      const tempRows = state.tempProductRows[product_id];
      if (tempRows) {
        const row = tempRows.find((row) => row.id === row_id);
        if (row) {
          row[key] = value;
        }
      }
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },
    removeTempProductRow: (state, action) => {
      const { product_id, row_id } = action.payload;
      const tempRows = state.tempProductRows[product_id];
      if (tempRows) {
        state.tempProductRows[product_id] = tempRows.filter(
          (row) => row.id !== row_id
        );
      }
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },
     setProductOrderType: (state, action) => {
      const { product_id, orderType } = action.payload;
      
      state.productItems = state.productItems.map(item => {
        if (item.product_id === product_id) {
          return {
            ...item,
            orderType 
          };
        }
        return item;
      });
      localStorage.setItem("productItems", JSON.stringify(state.productItems));
    },

    increaseModelItems: (state, action) =>{
      state.modelItems.push(action.payload);
      localStorage.setItem("modelItems", JSON.stringify(state.modelItems));

    },
    decreaseModelItems: (state, action) => {
  const itemIndex = state.modelItems.findIndex(item => item.id === action.payload);

  if (itemIndex !== -1) {
    state.modelItems.splice(itemIndex, 1);
  }

  localStorage.setItem("modelItems", JSON.stringify(state.modelItems));
  
  if (state.modelItems.length > 0) {
   
  }
},
    changeModelItems: (state, action) =>{
        const newItem = action.payload;   // { id, ...otherFields }

  // find index of item with same id
  const index = state.modelItems.findIndex(
    (item) => item.id === newItem.id
  );

  if (index !== -1) {
    // replace the existing item
    state.modelItems[index] = newItem;
  }
      localStorage.setItem("modelItems", JSON.stringify(state.modelItems));

    },
  },
});

export const {
  setProductOrderType,
  addProductColorCustomization,
  addProductCustomization,
  setProductItems,
  addProductRow,
  updateProductRow,
  deleteEntireProductCart,
  deleteProductRow,
  addTempProductRow,
  removeTempProductRow,
  updateTempProductRow,
  removeCart,
  deleteEntireGlbCart,
  deleteAllGlbItems,
  ConfigUrl,
  updateCartItem,
  setModifiedGLB,
  resetModifiedGLB,
  setSelectedAddressId,
  setSelectedSizeDetails,
  setglbId,
  addFavorite,
  removeFavorite,
  baseAssetUrl,
  setGlbItems,
  addGlbRow,
  deleteGlbRow,
  updateGlbRow,
  deleteEntireProductItems,
  increaseModelItems,
  decreaseModelItems
} = cartSlice.actions;

export default cartSlice.reducer;
